import { AssistantRuntime } from '@assistant-ui/react';
import { useEffect, useRef } from 'react';

export function useInitialMessage(runtime: AssistantRuntime, data: string | null) {
  const hasAppended = useRef(false);

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    // const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[arr.length - 1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:'application/pdf'});
  };

  useEffect(() => {
    if (!data || hasAppended.current) {return; }

    const appendMessage = () => {
      const threadState = runtime.threads.main.getState();
      const threadList = runtime.threads.getState();
      if (threadState.messages.length === 0 && !threadState.isRunning && !threadList.isLoading) {
        const composer = runtime.threads.main.composer;
        composer.setText('Analyze the file and provide a summary without charts');
        void composer.addAttachment(dataURLtoFile(data, 'attachment.pdf'));
        // runtime.threads.main.composer.addAttachment(dataURLtoFile(data, 'attachment.pdf'))
        /* runtime.threads.main.append({
          role: 'user',
          content: [{
            type: 'text', text: 'Analyze the file and provide a summary without charts'
          }],
          attachments: [{
            id: `${Date.now()}`,
            contentType: 'application/pdf',
            type: 'document',
            name: 'document.pdf',
            content: [
              {
                type: 'file',
                data: data,
                mimeType: 'application/pdf'
              },
            ],
            status: { type: 'complete' },
          }]
        });*/
        hasAppended.current = true;
        return true;
      }
      return false;
    };

    if (appendMessage()) {return; }

    const unsubscribe = runtime.threads.subscribe(() => {
      if (appendMessage()) {
        unsubscribe();
      }
    });
    return unsubscribe;
  }, [runtime, data, hasAppended.current]);
}

/*
  {
    role: "user",
    content: [{ type: "file", data: `data:application/pdf;base64,${basse_64_data}`, mimeType: 'application/pdf' }],
  }

 */
